export default __webpack_public_path__ + "media/mock/src/img/card_cvv-f31d9235db2050562b6bc544ecf4888f.svg";